<footer *transloco="let t; scope: 'footer'" class="flex w-full flex-none flex-col self-end px-3 md:flex-row">
  <div class="flex w-full md:w-1/2">
    <span class="text-onSurfaceVariant text-caption mr-2 flex flex-1 flex-col items-center gap-1 leading-4 md:flex-row">
      @for (m of metadata(); let i = $index; let last = $last; track $index) {
      <span>
        <span>{{ m.label }}: {{ m.value }}</span>
        @if (metadata.length > 1 && !last) {
        <span class="mx-2 hidden md:inline-block">|</span>
        }
      </span>
      }
    </span>
  </div>
  <div class="mx-4 flex flex-col flex-wrap items-center justify-center sm:mx-0 md:w-1/2 md:flex-row md:justify-end">
    <div class="mr-2">
      @for (footerLink of footerLinks; let i = $index; let last = $last; track $index) { @if (footerLink.external) {
      <a [href]="footerLink.link" target="_blank" rel="noopener noreferrer" class="text-onSurfaceVariant! text-caption py-1 leading-4">
        {{ footerLink.title }}
      </a>
      } @if (!footerLink.external) {
      <div
        [routerLink]="footerLink.link"
        class="footer-link-internal text-onSurfaceVariant text-caption inline-block cursor-pointer py-1 leading-4 outline-none"
      >
        {{ footerLink.title }}
      </div>
      } @if (!last) {
      <span class="separator text-onSurfaceVariant text-caption mx-1 py-1 leading-4">|</span>
      } } @if (appVersion()) {
      <span class="text-onSurfaceVariant text-caption mx-2 leading-4">{{ t('version') }}: {{ appVersion() }}</span>
      @if (isAdmin$()) {
      <span>🦄</span>
      } }
    </div>
    @if (displayFooterLogo()) {
    <div class="schaeffler-footer-logo"></div>
    }
    <a class="text-onSurfaceVariant text-caption opacity-0 transition hover:opacity-100" (click)="toggleDebug.emit('')"><mat-icon>adb</mat-icon></a>
  </div>
</footer>
